import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { ApiService } from '../../api/api.service';
import { FormactionService } from '../../api/formaction.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pduedit',
  templateUrl: './pduedit.component.html',
  styleUrls: ['./pduedit.component.css']
})
export class PdueditComponent implements OnInit {

  public ticketId: any;
  public entrydate: any;
  public state: any;
  public district: any;
  public iticode: any;
  public trade: any;
  public name: any;
  public email: any;
  public mobileno: any;
  public ccrefno: any;
  public ccrefnoStatus: any;
  public orderid: any;
  public date: any;
  public singlerollno: any;
  public bulkregno: any;
  public numberofstud: any;
  public amount: any;
  public descreption: any;

  public pduStatusForm: any;
  public submitted: any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private formaction: FormactionService, private router: Router) { }

  ngOnInit(): void {

    // var formData = new FormData();

    // formData.append("action", "check");
    // formData.append("ccav", '110118482965'); // number 123456 is immediately converted to a string "123456"



    // HTML file input, chosen by user

    // JavaScript file-like object

    // var request = new XMLHttpRequest();
    // request.open("POST", "https://nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenue.php");
    // request.send(formData);

    // alert(request.send(formData));

    // var myargs = { "action": "check", "ccav": '110118482965' };

    // alert(myargs)
    // var args = { ccav: 110102079296 };
    // this.api.getccref(myargs).subscribe((result: any) => {
    //   console.log("Res: " + JSON.stringify(result))
    // });

    this.pduStatusForm = this.formBuilder.group({
      refno: [''],
      email: [''],
      status: ['', Validators.required],
      statusDescription: ['', Validators.required]
    });

    this.formaction.get_pduList_single().subscribe((result: any) => {
      var args = {
        ticketId: result.ticketId
      }


      console.log(args)
      this.api.trackIdPdu(args).subscribe((result: any) => {
        console.log("Res: " + JSON.stringify(result))
        this.ticketId = result.ticketId;
        this.entrydate = result.entrydate;
        this.state = result.state;
        this.district = result.district;
        this.iticode = result.iticode;
        this.trade = result.trade;
        this.name = result.name;
        this.email = result.email;
        this.mobileno = result.mobileno;
        this.ccrefno = result.ccrefno;
        this.orderid = result.orderid;
        this.date = result.date;
        this.singlerollno = result.singlerollno;
        this.numberofstud = result.numberofstud;
        this.amount = result.amount;
        this.descreption = result.descreption;

        var args = this.ccrefno;
        

        this.api.ccrefStatus(args).subscribe((data: any) => {
          
          this.ccrefnoStatus = data.RefStatus;
         // alert(this.ccrefnoStatus)
          //console.log(data);
        });

      })
      this.api.trackIdPduBulkregno(args).subscribe((result: any) => {
        console.log(result);
        let bulkreg = '';
        result.forEach((element: any) => {
          bulkreg = bulkreg + element['regno'] + ',';
        });
        this.bulkregno = bulkreg.slice(0, -1);
      });

    });
  }

  get f() { return this.pduStatusForm.controls; }


  onSubmit() {


    this.pduStatusForm.controls["refno"].setValue(this.ticketId);
    this.pduStatusForm.controls["email"].setValue(this.email);
    // var a = this.eriStatusForm.controls["refno"] = this.trackId_refno;
    // this.eriStatusForm.controls["refno"].push('123')

    this.submitted = true;

    if (this.pduStatusForm.invalid) {
      return;
    }

    this.api.pdustatus(this.pduStatusForm.value).subscribe((result: any) => {
      console.log(result)
    })

    alert("Grievance status updated successfully");
    this.router.navigate(['/dashboard/pdulist']);

  }

}
